<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">

    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Supplier List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your supplier here</nz-page-header-subtitle>
      <nz-page-header-extra>
        <button nz-button nzType="default" (click)="openAboutDrawer()" style="margin-right: 8px;"
          nz-tooltip nzTooltipTitle="What each filter, column and field on this page means">
          <span nz-icon nzType="info-circle" nzTheme="outline"></span> About
        </button>
        @if (isTallyEnabled) {
          <app-tally-sync-history kind="Ledgers" style="display: inline-block; margin-right: 8px;"></app-tally-sync-history>
        }

        @if (this.permission.Add) {
          <span nz-tooltip
            [nzTooltipTitle]="canModifySupplier ? '' : 'Tally is enabled for this company, so adding suppliers also needs the Accounts - Tally Integration permission.'">
            <button nz-button nzType="primary" [disabled]="!canModifySupplier" (click)="showModal()">Add New</button>
          </span>
        }
      </nz-page-header-extra>

    </nz-page-header>
    <nz-divider></nz-divider>

    <!-- Collapsible Filter Panel -->
    <nz-collapse style="margin-bottom: 8px;">
      <nz-collapse-panel nzHeader="Filters" [nzActive]="false">
        <div nz-row [nzGutter]="24">
          <div nz-col [nzSpan]="5">
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <label>City</label>
                <nz-select [(ngModel)]="cityFilter" (ngModelChange)="onFilterChange()"
                  nzPlaceHolder="All Cities" nzAllowClear nzShowSearch style="width: 100%;">
                  @for (city of cityOptions; track city) {
                    <nz-option [nzValue]="city" [nzLabel]="city"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="5">
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <label>State</label>
                <nz-select [(ngModel)]="stateFilter" (ngModelChange)="onFilterChange()"
                  nzPlaceHolder="All States" nzAllowClear nzShowSearch style="width: 100%;">
                  @for (state of stateOptions; track state) {
                    <nz-option [nzValue]="state" [nzLabel]="state"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="5">
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <label>Country</label>
                <nz-select [(ngModel)]="countryFilter" (ngModelChange)="onFilterChange()"
                  nzPlaceHolder="All Countries" nzAllowClear nzShowSearch style="width: 100%;">
                  @for (country of countryOptions; track country) {
                    <nz-option [nzValue]="country" [nzLabel]="country"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="4">
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <label>Status</label>
                <nz-select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()"
                  style="width: 100%;"
                  nz-tooltip nzTooltipTitle="Disabled suppliers are hidden from supplier selections; find them here to re-enable">
                  <nz-option nzValue="active" nzLabel="Active"></nz-option>
                  <nz-option nzValue="disabled" nzLabel="Disabled"></nz-option>
                  <nz-option nzValue="all" nzLabel="All"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="5">
            <nz-form-item>
              <nz-form-control [nzSpan]="24">
                <label>Email Notifications</label>
                <nz-select [(ngModel)]="notificationFilter" (ngModelChange)="onFilterChange()"
                  style="width: 100%;"
                  nz-tooltip nzTooltipTitle="Filter suppliers by their email-notification opt-in">
                  <nz-option nzValue="all" nzLabel="All Suppliers"></nz-option>
                  <nz-option nzValue="enabled" nzLabel="Email Notifications: On"></nz-option>
                  <nz-option nzValue="disabled" nzLabel="Email Notifications: Off"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          @if (showTallyMapping) {
            <div nz-col [nzSpan]="4">
              <nz-form-item>
                <nz-form-control [nzSpan]="24">
                  <label>Tally Ledger</label>
                  <nz-select [(ngModel)]="tallyLinkFilter" (ngModelChange)="onFilterChange()"
                    style="width: 100%;"
                    nz-tooltip
                    nzTooltipTitle="Linked = mapped to a Tally supplier ledger. Unlinked suppliers need a ledger mapping before their invoices can be pushed to Tally.">
                    <nz-option nzValue="all" nzLabel="All Suppliers"></nz-option>
                    <nz-option nzValue="linked" nzLabel="Tally: Linked"></nz-option>
                    <nz-option nzValue="unlinked" nzLabel="Tally: Not Linked"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          }
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <div style="padding: 8px;float:right">
      <input type="text" style="width: 250px;margin-right: 8px;" nz-input placeholder="Search name / code / email / phone"
        [(ngModel)]="searchValue"   (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()"

        />
      <button nz-button nzSize="small" nzType="primary" (click)="search()" style="margin-right: 8px;">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()"><i nz-icon nzType="export" nzTheme="outline"></i>
    Export</button>
  </div>
  <nz-table nzSize="small" style="width: 100%;" [nzScroll]="{ x: '1500px',y:'515px' }" #basicTable
    [nzData]="this.SupplierList" [nzLoading]="isTableLoading" nzBordered
    nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50, 100, 200]"
    [(nzPageIndex)]="pageIndex" [(nzPageSize)]="pageSize"
    [nzShowTotal]="totalTemplate">
    <thead>
      <tr>
        <th nzWidth="60px" nzLeft>#</th>
        <th nzWidth="250px" nzLeft>
          Supplier
          <div class="th-secondary" nz-tooltip nzTooltipTitle="System-generated code that identifies this supplier in other applications">Name / Code</div>
        </th>
        <th nzWidth="230px">
          Contact
          <div class="th-secondary">Number / Email</div>
        </th>
        <th nzWidth="180px">
          Contact Person
          <div class="th-secondary">Name / Number</div>
        </th>
        <th nzWidth="280px">Address</th>
        <th nzWidth="190px">
          Location
          <div class="th-secondary">City, State / Country</div>
        </th>
        <th nzWidth="170px">
          <span nz-tooltip nzTooltipTitle="Goods and Services Tax identification number">GST</span>
          <div class="th-secondary">Number / Registration Type</div>
        </th>
        @if (showTallyMapping) {
          <th nzWidth="200px" nz-tooltip nzTooltipTitle="The Tally party ledger this supplier's purchase vouchers post to">Tally Ledger</th>
        }
        <th nzWidth="160px" style="text-align:center" nzRight>Action</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data.SupplierId; let i = $index) {
        <tr>
          <td nzLeft>{{ (pageIndex - 1) * pageSize + i + 1 }}</td>
          <td nzLeft>
            <div>
              {{ data.SupplierName }}
              @if (data.Disabled) {
                <nz-tag nzColor="red" nz-tooltip
                  nzTooltipTitle="This supplier is disabled and hidden from supplier selections. Use Enable to bring it back.">Disabled</nz-tag>
              }
            </div>
            @if (data.SupplierCode) {
              <div class="cell-secondary">{{ data.SupplierCode }}</div>
            }
          </td>
          <td>
            <div>{{ data.SupplierContactNumber }}</div>
            <div class="email-cell cell-secondary">
              <span class="email-text" [title]="data.Email">{{ data.Email }}</span>
              @if (data.IsEmailNotificationEnabled) {
                <span nz-tooltip
                  nzTooltipTitle="Email notifications enabled for this supplier"
                  class="notification-icon email-icon">
                  <i nz-icon nzType="mail" nzTheme="fill"></i>
                </span>
              }
            </div>
          </td>
          <td>
            <div>{{ data.ContactPersonName }}</div>
            <div class="cell-secondary">{{ data.ContactPersonNumber }}</div>
          </td>
          <td>{{ data.Address }}</td>
          <td>
            <div>{{ cityStateOf(data) }}</div>
            @if (data.Country) {
              <div class="cell-secondary">{{ data.Country }}</div>
            }
          </td>
          <td>
            <div>{{ data.Gst }}</div>
            @if (data.GstRegistrationType) {
              <div class="cell-secondary">{{ gstRegistrationTypeLabel(data.GstRegistrationType) }}</div>
            }
          </td>
          @if (showTallyMapping) {
            <td>
              @if (data.TallyLedgerName) {
                <nz-tag nzColor="green">{{ data.TallyLedgerName }}</nz-tag>
              } @else {
                <span style="color: #8c8c8c;">Not mapped</span>
              }
            </td>
          }
          <td nzRight style="text-align:center">
            <span nz-tooltip
              [nzTooltipTitle]="canModifySupplier ? '' : 'Tally is enabled for this company, so editing suppliers also needs the Accounts - Tally Integration permission.'">
              <button class="btn btn-sm btn-light-primary" [disabled]="!canModifySupplier" (click)="OpenEditPop(data)">Edit</button>
            </span> &nbsp;
            @if (permission.Delete) {
              @if (data.Disabled) {
                <button class="btn btn-sm btn-light-success" (click)="EnableSupplier(data)">Enable</button>
              } @else {
                <button class="btn btn-sm btn-light-danger" (click)="handleDelete(data)">Disable</button>
              }
            }
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
  <ng-template #totalTemplate let-total let-range="range">
    Showing {{ range[0] }} to {{ range[1] }} of {{ total }} suppliers
  </ng-template>


  <nz-modal [nzWidth]="800" [nzStyle]="{ top: '20px' }" [(nzVisible)]="isVisible" [nzTitle]="modalTitle"
    [nzContent]="modalContent" [nzFooter]=null (nzOnCancel)="handleCancel()">
    <ng-template #modalTitle>{{PopUpTitle}}</ng-template>

    <ng-template #modalContent>
      <form nz-form [formGroup]="validateForm" (ngSubmit)="handleOk()">
        <nz-form-item>

          <nz-form-label [nzSpan]="8" nzRequired>Supplier Name</nz-form-label>
          <nz-form-control [nzSpan]="14" [nzErrorTip]="NameError">
            <input nz-input formControlName="SupplierName" name="SupplierName" />
          </nz-form-control>
        </nz-form-item>

        <!-- Sits directly under the name because picking the ledger fills the tax
             identity below it: choose the party in Tally first, then fill in what
             only the ERP knows (contacts, city). -->
        @if (showTallyMapping) {
          <nz-form-item>
            <nz-form-label [nzSpan]="8"><span nz-tooltip nzTooltipTitle="The Tally party ledger (creditor or debtor) this supplier's purchase vouchers post to. Picking it fills the GSTIN, address, state, PIN and registration type from Tally.">Tally Supplier Ledger</span></nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-radio-group [(ngModel)]="tallyLedgerSide" [ngModelOptions]="{standalone: true}"
                nzButtonStyle="solid" nzSize="small" style="margin-bottom: 8px;"
                (ngModelChange)="onTallyLedgerSideChange()" nz-tooltip
                nzTooltipTitle="Creditors is the usual list. Choose Debtors when this supplier is kept under Sundry Debtors in Tally — for example a party that is also a customer.">
                <label nz-radio-button nzValue="Creditors">Creditors</label>
                <label nz-radio-button nzValue="Debtors">Debtors</label>
              </nz-radio-group>
              <div style="display: flex; gap: 8px; align-items: center;">
                <nz-select #tallyLedgerSelect style="flex: 1;" [(ngModel)]="NewSupplier.TallyLedgerName"
                  [ngModelOptions]="{standalone: true}"
                  nzShowSearch nzServerSearch nzAllowClear
                  [nzLoading]="isTallyLedgersLoading"
                  (nzOnSearch)="onTallyLedgerSearch($event)"
                  (ngModelChange)="onTallyLedgerChange($event)"
                  nzPlaceHolder="Pick the ledger from Tally Sync">
                  @for (ledger of tallyLedgerOptions; track ledger.LedgerName) {
                    <nz-option [nzValue]="ledger.LedgerName"
                      [nzLabel]="ledger.LedgerName + (ledger.Gstin ? ' — ' + ledger.Gstin : '')"></nz-option>
                  }
                </nz-select>
                <button nz-button nzType="default" type="button" [nzLoading]="isRequestingLedgerSync"
                  (click)="requestLedgerSync()" nz-tooltip
                  nzTooltipTitle="Read the latest ledger list from Tally. Use this when a ledger was just created in Tally.">
                  <span nz-icon nzType="sync" nzTheme="outline"></span>
                </button>
              </div>
              <app-tally-sync-run-status #ledgerSyncStatus kind="Ledgers" (completed)="loadTallyLedgers()"></app-tally-sync-run-status>
              @if (tallyLockedFields.length > 0) {
                <div class="tally-fill-hint">
                  <span nz-icon nzType="lock" nzTheme="outline"></span>
                  Filled from Tally and locked so both systems carry the same details.
                  Clear the ledger above to edit them here.
                </div>
              }
              @if (tallyUnlockedFields.length > 0) {
                <div class="tally-fill-hint tally-fill-hint-warn">
                  <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
                  Tally does not check these, and what it holds is not valid here, so they are
                  left open for you to correct:
                  <ul class="tally-unlocked-list">
                    @for (item of tallyUnlockedFields; track item.label) {
                      <li>{{ item.label }} &mdash; Tally has <strong>{{ item.tally }}</strong></li>
                    }
                  </ul>
                </div>
              }
            </nz-form-control>
          </nz-form-item>

          @if (tallyMismatches.length > 0) {
            <nz-alert nzType="warning" nzShowIcon style="margin-bottom: 16px;"
              nzMessage="This supplier's details differ from its Tally ledger"
              [nzDescription]="tallyMismatchTemplate"></nz-alert>
            <ng-template #tallyMismatchTemplate>
              <ul style="margin: 0 0 8px 0; padding-left: 18px;">
                @for (item of tallyMismatches; track item.label) {
                  <li>{{ item.label }}: <strong>{{ item.tally }}</strong> in Tally, {{ item.erp }} here</li>
                }
              </ul>
              <button nz-button nzType="primary" nzSize="small" type="button" (click)="useTallyValues()">
                Use Tally's values
              </button>
            </ng-template>
          }
        }

        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Supplier Contact Number</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Enter mobile number">
            <input nz-input formControlName="SupplierContactNumber" type="number" name="SupplierContactNumber" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="8">Email</nz-form-label>
          <nz-form-control pattern="emailPattern" [nzSpan]="14" nzErrorTip="Invalid Email">
            <input nz-input formControlName="Email" name="Email" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Contact Person Name</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Contact Person Name required">
            <input nz-input formControlName="ContactPersonName" name="ContactPersonName" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Contact Person Number</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Enter valid 10 digit mobile number">
            <input nz-input formControlName="ContactPersonNumber" name="ContactPersonNumber" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Address</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Address required">
            <textarea nz-input formControlName="Address" name="Address required"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8">City</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="City" name="City" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8">State</nz-form-label>
          <nz-form-control [nzSpan]="14">
            @if (isIndia) {
              <nz-select formControlName="State" nzShowSearch nzAllowClear
                nzPlaceHolder="Select state">
                @for (state of states; track state.gstCode) {
                  <nz-option [nzValue]="state.name" [nzLabel]="state.name"></nz-option>
                }
              </nz-select>
            } @else {
              <input nz-input formControlName="State" name="State" placeholder="State / province" />
            }
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8">Country</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="Country" name="Country" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8"><span nz-tooltip nzTooltipTitle="Postal Index Number — 6-digit Indian postal code">Pincode</span></nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="An Indian PIN code has 6 digits and does not start with 0">
            <input nz-input formControlName="Pincode" name="Pincode" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8"><span nz-tooltip nzTooltipTitle="How this supplier is registered under GST, spelt as Tally spells it. Choose Unknown for foreign suppliers — they have no GSTIN.">GST Registration Type</span></nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-select formControlName="GstRegistrationType" nzAllowClear nzPlaceHolder="Select registration type">
              @for (type of gstRegistrationTypes; track type.value) {
                <nz-option [nzValue]="type.value" [nzLabel]="type.label"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" [nzRequired]="isGstinMandatory"><span nz-tooltip nzTooltipTitle="Goods and Services Tax identification number — 15 characters. Mandatory for Regular, Composition and Regular - SEZ suppliers.">GST / TAX</span></nz-form-label>
          <nz-form-control [nzSpan]="14" [nzErrorTip]="gstErrorTip">
            <input nz-input formControlName="Gst" name="Gst" placeholder="e.g. 09ABCDE1234F1Z5" />
          </nz-form-control>
        </nz-form-item>
        @if (NewSupplier.SupplierId > 0) {
          <nz-form-item>
            <nz-form-label [nzSpan]="8"><span nz-tooltip nzTooltipTitle="System-generated code that identifies this supplier in other applications. It never changes.">Supplier Code</span></nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input nz-input [ngModel]="NewSupplier.SupplierCode || 'Will be generated on save'"
                [ngModelOptions]="{standalone: true}" disabled />
            </nz-form-control>
          </nz-form-item>
        }
        <nz-form-item>
          <nz-form-label [nzSpan]="8">Email Notifications</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-switch [(ngModel)]="NewSupplier.IsEmailNotificationEnabled"
              [ngModelOptions]="{standalone: true}"
              [nzDisabled]="!isEmailValidForNotification"
              nz-tooltip
              [nzTooltipTitle]="isEmailValidForNotification
                ? 'When ON, this supplier receives notification emails such as quality-inspection outcomes and delivery-delay reminders.'
                : 'Enter a valid email address above to enable notifications.'">
            </nz-switch>
          </nz-form-control>
        </nz-form-item>
        <!-- <ng-template #modalFooter>

        <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>

      </ng-template> -->
      <div class="text-center">
        <button nz-button nzType="primary" [nzLoading]="isLoading">Save Supplier</button>
      </div>

    </form>
  </ng-template>
</nz-modal>

</div>
</div>

<!-- About Drawer -->
<nz-drawer
  [nzVisible]="isAboutDrawerOpen"
  nzTitle="About Supplier List"
  nzPlacement="right"
  nzWidth="clamp(480px, 50vw, 900px)"
  [nzClosable]="true"
  (nzOnClose)="closeAboutDrawer()">
  <ng-container *nzDrawerContent>

    <h4>What this page does</h4>
    <p>
      This is the list of every supplier you buy from. Use it to find a supplier, check their contact and tax
      details, add a new supplier, correct an existing one, or switch a supplier off so it no longer appears
      when people pick a supplier on other pages.
    </p>

    <nz-divider nzText="Finding suppliers"></nz-divider>
    <p>
      <strong>Search box:</strong> type part of a supplier's name, code, email, phone number, address, city,
      state, contact person, GST number or Tally ledger name, then press Enter or click Search.
    </p>
    <p>
      <strong>Search:</strong> applies the words you typed together with any filters you have chosen.
    </p>
    <p>
      <strong>Reset:</strong> clears the search box and every filter, and shows active suppliers again.
    </p>
    <p>
      <strong>Export:</strong> downloads the supplier details as a file you can open in Excel.
    </p>
    <p>
      <strong>Filters (click the Filters bar to open it):</strong> each filter narrows the list straight away.
    </p>
    <ul>
      <li><strong>City, State, Country:</strong> show only suppliers in that place. These lists offer only places
        that at least one supplier actually has.</li>
      <li><strong>Status:</strong> Active (the default) hides disabled suppliers, Disabled shows only the ones
        switched off, and All shows both. Use Disabled to find a supplier you want to bring back.</li>
      <li><strong>Email Notifications:</strong> show only suppliers who receive notification emails, only those who
        do not, or all of them.</li>
      <li><strong>Tally Ledger:</strong> show suppliers that are linked to a Tally ledger, or those that are not
        linked yet. A supplier that is not linked needs a ledger before its invoices can be sent to Tally. This
        filter appears only when your company uses Tally and you have the Tally Integration permission.</li>
    </ul>

    <nz-divider nzText="The supplier table"></nz-divider>
    <p><strong>#:</strong> the row number in the list you are looking at.</p>
    <p>
      <strong>Supplier:</strong> the supplier's name, with its code underneath. The code is made by the system
      so that the supplier can be recognised in other applications. A red Disabled tag means the supplier is
      switched off.
    </p>
    <p>
      <strong>Contact:</strong> the supplier's phone number, with the email address underneath. A small mail icon
      beside the email means this supplier receives notification emails.
    </p>
    <p><strong>Contact Person:</strong> the name and phone number of the person you deal with.</p>
    <p><strong>Address:</strong> the supplier's full address.</p>
    <p><strong>Location:</strong> city and state, with the country underneath.</p>
    <p>
      <strong><span nz-tooltip nzTooltipTitle="GST - Goods and Services Tax">GST</span>:</strong>
      the supplier's GST number, with how they are registered underneath (for example Regular, or Unknown for an overseas supplier).
    </p>
    <p>
      <strong>Tally Ledger:</strong> the Tally account this supplier's purchase vouchers are posted to, or "Not
      mapped" if none has been chosen. This column appears only when your company uses Tally and you have the
      Tally Integration permission.
    </p>
    <p>
      <strong>Action:</strong> <em>Edit</em> opens the supplier's details. <em>Disable</em> switches the supplier
      off after you confirm; its past orders, receipts and invoices keep showing it, but it disappears from
      supplier selections. <em>Enable</em> (shown on disabled suppliers) brings it back. You see Disable and
      Enable only if you have the Delete permission.
    </p>
    <p>
      <strong>Table footer:</strong> shows which rows you are looking at and how many suppliers there are. You can
      change how many rows appear on each page.
    </p>

    <nz-divider nzText="Adding or editing a supplier"></nz-divider>
    <p>
      <strong>Add New:</strong> opens a blank supplier form. It appears only if you have the Add permission. When
      your company uses Tally, adding and editing suppliers also needs the Accounts - Tally Integration
      permission; without it the button is greyed out and a tip explains why.
    </p>
    <p>
      <strong>Supplier Name (required):</strong> at least 3 characters, and not the same as another supplier's name.
    </p>
    <p>
      <strong>Tally Supplier Ledger:</strong> see the Tally section below. It sits right under the name because
      choosing a ledger fills in several of the fields further down.
    </p>
    <p><strong>Supplier Contact Number (required):</strong> the supplier's main phone number.</p>
    <p>
      <strong>Email:</strong> the supplier's email address. It must be a valid address if you enter one.
    </p>
    <p><strong>Contact Person Name and Contact Person Number (required):</strong> the person you deal with and how to reach them.</p>
    <p><strong>Address (required):</strong> the supplier's address.</p>
    <p><strong>City:</strong> the supplier's city.</p>
    <p>
      <strong>State:</strong> for an Indian supplier, pick the state from the list. For a supplier in another
      country, type the state or province.
    </p>
    <p><strong>Country:</strong> defaults to India.</p>
    <p>
      <strong><span nz-tooltip nzTooltipTitle="Postal Index Number - the 6-digit Indian postal code">Pincode</span>:</strong>
      for an Indian supplier it must be 6 digits and cannot start with 0. For a supplier in another country the
      postal code can be in any format.
    </p>
    <p>
      <strong>GST Registration Type:</strong> how the supplier is registered for GST, using the same names as
      Tally: Regular, Composition, Regular - SEZ, Unregistered, Unregistered/Consumer, Consumer or Unknown.
      Choose Unknown for foreign suppliers, who have no GST number; Tally uses Unknown for them too. Picking a
      Tally ledger fills this in from Tally.
    </p>
    <p>
      <strong><span nz-tooltip nzTooltipTitle="GSTIN - the 15-character GST identification number">GST / TAX</span>:</strong>
      the supplier's 15-character GST number. It is required for Regular, Composition and Regular - SEZ suppliers. It must
      be in the correct format, and its first two digits must match the state you chose. Unknown (foreign)
      suppliers are not checked.
    </p>
    <p>
      <strong>Supplier Code:</strong> shown when you edit a supplier. It is made by the system, never changes, and
      cannot be edited.
    </p>
    <p>
      <strong>Email Notifications:</strong> when switched on, the supplier receives notification emails such as
      quality-inspection results and delivery-delay reminders. It can be switched on only when a valid email
      address is entered, and it switches itself off if the email is removed or becomes invalid.
    </p>
    <p><strong>Save Supplier:</strong> saves the supplier. If something is not acceptable, a message explains what to correct and the form stays open.</p>

    <nz-divider nzText="Tally"></nz-divider>
    <p>
      <strong>Tally Supplier Ledger:</strong> picks the supplier's account in
      <span nz-tooltip nzTooltipTitle="TallyPrime - the accounting software installed on a computer in your office">Tally</span>,
      so that purchase vouchers for this supplier post to it. Type to search. Each ledger can belong to only one
      supplier, so ledgers already used by another supplier are not offered.
    </p>
    <p>
      <strong>Creditors / Debtors switch:</strong> above the ledger list. It starts on Creditors, which is right for
      most suppliers. Switch to Debtors for a supplier that Tally keeps under Sundry Debtors, which is often a party
      that is also a customer. The list then shows the debtor ledgers that no other supplier has linked. Switching
      only changes the list; a ledger you have already picked stays selected. When you open a supplier whose ledger is
      a debtor, the page opens on Debtors by itself.
    </p>
    <p>
      <strong>What choosing a ledger does:</strong> the supplier's GST number, GST registration type, address,
      state and country are copied from the Tally ledger, and so is the pincode when it is valid. The fields it
      filled are locked so that both systems carry the same details; clear the ledger to edit them here. Anything
      Tally has no value for stays open for you to type. If Tally holds a pincode that is not valid here, it is
      filled in but left open, and the page lists it so you can correct it.
    </p>
    <p>
      <strong>When details differ:</strong> if you open a supplier that is already linked and its saved details
      differ from the Tally ledger, a warning lists each difference. <em>Use Tally's values</em> replaces the
      supplier's details with what Tally holds.
    </p>
    <p>
      <strong>Refresh button (the circular arrows next to the ledger):</strong> asks Tally for its latest ledger
      list. Use it when a ledger was just created in Tally and is not showing yet. The refresh needs Tally to be
      open at the company on the Tally machine, and the Tally agent on that machine does the reading, so it may
      take a few minutes. If a refresh is already running, the page follows that one instead of starting another.
    </p>
    <p>
      The refresh reads only what changed in Tally since the last refresh, not every ledger again, and the status
      line beside the button shows its progress. A ledger that is renamed in Tally keeps its link: the supplier's
      Tally ledger name follows the rename, so nothing needs to be re-picked.
    </p>
    <p><strong>The status line under the button</strong> tells you how the latest refresh is going:</p>
    <ul>
      <li><strong>Waiting for the Tally agent to pick this up:</strong> the request is made but the agent has not
        started yet.</li>
      <li><strong>Reading from Tally:</strong> the agent is reading the ledgers now.</li>
      <li><strong>Last refreshed from Tally:</strong> the refresh finished. It shows when, and how many ledgers
        were read. The ledger list then reloads by itself.</li>
      <li><strong>Last refresh failed:</strong> the refresh did not work, with the reason. <strong>No answer from
        Tally</strong> means Tally did not reply. Check that Tally is open at the right company, then try again.</li>
    </ul>
    <p>
      Hover over the status line to see the full detail. While a refresh is in progress the line updates by itself.
      If no refresh has ever been made, no line is shown.
    </p>
    <p>
      The Tally parts of this page appear only when your company uses Tally and you have the Accounts - Tally
      Integration permission.
    </p>
    <p>
      <strong>Tally Sync History (button at the top):</strong> shown whenever your company uses Tally, to
      everyone who can open this page. It lists the ledger refreshes from Tally of the last 30 days, newest first:
      when each was asked for, how it went, how many ledgers were read, the full reason when one failed, and who
      asked. Refreshes older than 30 days are removed.
    </p>

  </ng-container>
</nz-drawer>
